var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasAnyPermission)?_c('v-container',{staticClass:"pa-10",attrs:{"fluid":"","id":"regular-tables","tag":"section"}},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":""}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }